import React from "react";
import HomeLayout from "../layouts/home";
import { useEffect } from "react";
import { API_BASE_URL } from "../lib/constants";
import Cookie, { JWT_COOKIE_NAME } from "../lib/cookie";
import { useToast } from "../hooks/use-toast";
import { useTranslation } from "../contexts/I18nProvider";

function PaymentCompleted() {
  const toast = useToast();
  const { t } = useTranslation();

  useEffect(() => {
    // Get the paymentIntent ID from the URL
    const urlParams = new URLSearchParams(window.location.search);
    const paymentIntentId = urlParams.get("payment_intent");

    // If paymentIntentId exists, send it to the backend
    if (paymentIntentId) {
      // Send request to /api/payment-intent/success to update payment status
      fetch(API_BASE_URL + "/api/payment-intent/success", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookie.get(JWT_COOKIE_NAME)}`,
        },
        body: JSON.stringify({ paymentIntentId }), // Send paymentIntentId in the request body
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.message) {
            toast({
              title: "Success!",
              description: data.message,
            });
          }
        })
        .catch((error) => {
          console.error("Error updating payment status:", error);
        });
    }
  }, []);

  return (
    <HomeLayout>
      <div className="rounded-xl bg-accent p-6  md:mx-auto my-auto">
        <svg
          viewBox="0 0 24 24"
          className="text-emerald-600 w-16 h-16 mx-auto my-6"
        >
          <path
            fill="currentColor"
            d="M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z"
          ></path>
        </svg>
        <div className="text-center">
          <h3 className="md:text-2xl text-base text-black font-semibold text-center">
            {t('pages.paymentCompleted.title')}
          </h3>
          <p className="text-black my-2">
            {t('pages.paymentCompleted.message')}
          </p>
          <p> {t('pages.paymentCompleted.exclamation')} </p>
          <div className="py-10 text-center">
            <a
              href="/polyglot-library"
              className="px-12 rounded-xl transition-colors duration-100 ease-in-out bg-primary/90 hover:bg-primary text-white font-semibold py-4"
            >
              {t('pages.paymentCompleted.cta')}
            </a>
          </div>
        </div>
      </div>
    </HomeLayout>
  );
}

export default PaymentCompleted;
